import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { format as formatDate } from 'date-fns';

import { Table, Typography } from 'wtb-components';
import { useTransactionContext } from 'context';
import styles from './PrintOrderDetails.module.css';

const PrintOrderDetails = () => {
  const { t: translate } = useTranslation();

  const { merchant, order } = useTransactionContext();

  const [ rows, setRows ] = useState([]);
  const [ date, setDate ] = useState();

  useEffect(() => {
    if (order.orderDate) {
      setDate(new Date(order.orderDate));
    }
  }, [ order.orderDate, setDate ]);

  useEffect(() => {
    if (!merchant.name) return;

    const _rows = [];

    if (date) {
      _rows.push([
        {
          className: styles.tableResultsCellText,
          content: (
            <Typography variant="body2" component="div">
              {translate('printOrderDetails.orderDate')}
            </Typography>
          )
        },
        {
          className: styles.tableResultsCellValue,
          colSpan: 2,
          content: (
            <Typography variant="body2" color="textSecondary" component="div" align="right">
              {formatDate(date, 'dd/MM/yyyy')}
            </Typography>
          )
        }
      ]);
    }

    _rows.push([
      {
        className: styles.tableResultsCellText,
        content: (
          <Typography variant="body2" component="div">
            {translate('printOrderDetails.store')}
          </Typography>
        )
      },
      {
        className: styles.tableResultsCellValue,
        colSpan: 2,
        content: (
          <Typography variant="body2" color="textSecondary" component="div" align="right">
            {merchant.name}
          </Typography>
        )
      }
    ]);

    setRows([ ..._rows ]);
  }, [
    styles.tableResultsCellText,
    styles.tableResultsCellValue,
    merchant.name,
    date,
    translate
  ]);

  return (
    <div className={styles.root}>
      <Table
        rows={rows.map((x) => ({ items: x }))}
        rowDivider={false}
        rowCellClassName={styles.tableCell}
        aria-label="details-table"
      />
    </div>
  );
};

export default PrintOrderDetails;
